import { TaskStatus } from "../reducers/user/types";

export const getFormattedStatus = (status?: string): string => {
  switch (status) {
    case TaskStatus.PENDING:
     return 'PENDING';
    case TaskStatus.IN_PROGRESS:
      return 'IN PROGRESS'
    case TaskStatus.COMPLETE:
      return 'COMPLETED';
    case TaskStatus.CANCELLED:
      return 'CANCELLED';
    default:
      return '-';
  }
};